const Url = window.SabreConfig || ((process.env.NODE_ENV === 'DEV')
    ? {
    // host: window.location.protocol.concat('//').concat(window.location.hostname).concat(":").concat(window.location.port),
    host: window.location.protocol.concat('//').concat(window.location.hostname).concat(":").concat('8080'),
    authenticationUrl: 'http://10.26.162.39:8080/shs-security-services/v1/auth/token',
    hotelListUrl: 'http://10.26.162.39:8080/shs-security-services/v1/auth/token/hotellist',
    authenticationUrl2:'http://10.28.177.60:8080/shs-security-services/v1/auth/token',
    hotelListUrl2: 'http://10.28.177.60:8080/shs-security-services/v1/auth/token/hotellist',
    token: '/ct-presentation-service/v1/auth/token',
    summary: '/ct-presentation-service/v1/presentation/summary',
    upload: '/ct-presentation-service/v1/presentation/upload',
    download: '/ct-presentation-service/v1/presentation/download',
    iframe: 'https://ngba-test2.synxis.com/?hotel=14845&chain=6990&croid=6992',
    // iframe: 'https://ngba-test.synxis.com/?hotel=14845&chain=6990&croid=6992',
    // iframe: 'http://localhost:8888/ct-presentation-service/?hotel=14845&chain=6990&croid=6992',
    // ...
  }
    : { // Until now: UNKNOWN! Need to be added when SABRE is offering them!
    host: window.location.protocol.concat('//').concat(window.location.hostname).concat(":").concat(window.location.port),
    token: '/ct-presentation-service/v1/auth/token',
    authenticationUrl: 'http://10.26.162.39:8080/shs-security-services/v1/auth/token',
    hotelListUrl: 'http://10.26.162.39:8080/shs-security-services/v1/auth/token/hotellist',
    authenticationUrl2:'http://10.28.177.60:8080/shs-security-services/v1/auth/token',
    hotelListUrl2: 'http://10.28.177.60:8080/shs-security-services/v1/auth/token/hotellist',
    summary: '/ct-presentation-service/v1/presentation/summary',
    upload: '/ct-presentation-service/v1/presentation/upload',
    download: '/ct-presentation-service/v1/presentation/download',
    iframe: 'https://ngba-test2.synxis.com/?hotel=14845&chain=6990&croid=6992',
    // ...
  })
  ;

export default Url;



// WEBPACK FOOTER //
// ./lib/config.js